var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompetedIconSmall = function SvgCompetedIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.53 8.97a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06L11 13.44l4.47-4.47a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  })));
};
export default SvgCompetedIconSmall;